import { FocusArea } from "../content";
import { FocusIcon } from "./icons";

export function FocusAreaItem({ area, index }: { area: FocusArea; index: number }) {
  return (
    <article className="focus-item">
      <span className="focus-icon">
        <FocusIcon index={index} />
      </span>
      <h3>{area.title}</h3>
      <p>{area.description}</p>
    </article>
  );
}
